import { privateRoutes } from 'view/routes';
import featureFlags from 'modules/featureFlags';
import PermissionChecker from 'modules/auth/permissionChecker';

const matchPermissions = ({ permission, currentUser, scopes, environment }) => {
  const permissionChecker = new PermissionChecker(
    currentUser,
    scopes,
    environment,
  );

  return permissionChecker.check(permission);
};

export const isRouteAllowedForAppTraits = ({ routeTraits, appTraits }) => {
  if (!routeTraits) return true;

  const { required: requiredTraits, excluded: excludedTraits } = routeTraits;

  // Show only if all required route traits are present
  if (
    requiredTraits &&
    !requiredTraits.every(requiredTrait => appTraits.includes(requiredTrait))
  ) {
    return false;
  }

  // Hide if any excluded route trait is present
  return !(
    excludedTraits &&
    excludedTraits.some(excludedTrait => appTraits.includes(excludedTrait))
  );
};

export const getEnabledPrivateRoutes = ({
  currentUser,
  scopes,
  environment,
  appTraits,
}) =>
  privateRoutes
    .filter(privateRoute => privateRoute.menu)
    .filter(privateRoute => {
      if (!privateRoute.featureFlag) {
        return true;
      }

      return featureFlags.isOn(privateRoute.featureFlag);
    })
    .filter(privateRoute =>
      matchPermissions({
        permission: privateRoute.permissionRequired,
        currentUser,
        scopes,
        environment,
      }),
    )
    .filter(privateRoute =>
      isRouteAllowedForAppTraits({
        routeTraits: privateRoute.traits,
        appTraits,
      }),
    )
    .filter(
      privateRoute =>
        !(
          privateRoute.showOnlyOnEnv &&
          privateRoute.showOnlyOnEnv !== environment
        ),
    );
